<template>
  <a-row :gutter="24" style="height: 100%">
    <a-col :md="24" :sm="24" style="height: 100%">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :span="16">
              <a-form-item :label="$t('距今')">
                <a-select v-model="condition" style="width: 30%" @change="handleperiodChange">
                  <a-select-option v-for="meterperiod in conditionData" :key="meterperiod.key" :value="meterperiod.key">
                    {{ meterperiod.title }}
                  </a-select-option>
                </a-select>
                <a-select v-model="punctuation" style="width: 18%; margin-left: 5px">
                  <a-select-option v-for="rate in symbol" :key="rate">
                    {{ rate }}
                  </a-select-option>
                </a-select>
                <a-input-number
                  v-model="queryParam.days"
                  :min="1"
                  :precision="0"
                  style="width: 30%; margin-left: 5px"
                ></a-input-number>
                <a-select v-model="monad" style="width: 10%; margin-left: 5px">
                  <a-select-option v-for="time in units" :key="time">
                    {{ $t(time) }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('表类型')">
                <j-dict-select-tag v-model="queryParam.meterType" :placeholder="$t('请表类型')" dictCode="meter_type" />
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                <a-button type="primary" icon="download" @click="handleExportXls($t('未上报查询'))" style="margin-left: 8px"
                  >{{ $t('导出') }}</a-button
                >
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- table区域-begin -->
      <div class="table-fixed">
        <div class="radio_button_group">
          <a-radio-group button-style="solid" v-model="radioValue" style="margin-bottom: 16px" @change="changeRadio">
            <a-radio-button value="1">{{ $t('设备列表') }}</a-radio-button>
            <a-radio-button value="2">{{ $t('厂商对比') }}</a-radio-button>
          </a-radio-group>
        </div>
        <!-- 设备列表 -->
        <a-table
          ref="table"
          size="middle"
          :scroll="{ x: true }"
          bordered
          rowKey="id"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          :components="drag(columns)"
          @change="handleTableChange"
          v-if="radioValue == 1"
        >
        </a-table>
        <!-- 厂商对比 -->
        <div style="height: 100%" v-if="radioValue == 2">
          <div class="top_list">
            <div v-for="item in taskList" :key="item.key" class="top_item">
              <div>
                <div class="label">{{ $t(item.label) }}</div>
                <div class="num">
                  <span v-if="item.key == 1">{{ item.num }}%</span>
                  <span v-if="item.key == 2">{{ item.num }}</span>
                  <span v-if="item.key == 3">{{ item.num }}{{ $t('条') }}</span>
                </div>
                <!-- <div>
                  <a-tag color="green" v-if="item.key == 1">环比 +0.6%</a-tag>
                  <a v-if="item.key == 3">立即处理</a>
                </div> -->
              </div>
              <div>
                <div class="progress" v-if="item.key == 1">
                  <a-progress type="circle" strokeColor="#87d068" :strokeWidth="10" :percent="item.num" :width="60" />
                </div>
                <div class="icon blue" v-else-if="item.key == 2">
                  <a-icon type="check-circle" theme="filled" />
                </div>
                <div class="icon red" v-else-if="item.key == 3">
                  <a-icon type="close-circle" theme="filled" />
                </div>
              </div>
            </div>
          </div>
          <div class="chart-container">
            <div class="item">
              <a-card size="small" :title="$t('设备上报率')">
                <div slot="extra">
                  <!-- <a-radio-group button-style="solid" size="small" v-model="cycleValue" @change="changeCycle">
                    <a-radio-button value="1">日</a-radio-button>
                    <a-radio-button value="2">周</a-radio-button>
                    <a-radio-button value="3">月</a-radio-button>
                  </a-radio-group> -->
                </div>
                <div id="chart1" style="height: 100%; width: 100%"></div>
              </a-card>
            </div>
            <div class="item">
              <a-card size="small" :title="$t('厂商设备对比')">
                <a-table
                  ref="table"
                  size="middle"
                  :scroll="{ x: false }"
                  bordered
                  rowKey="id"
                  :columns="columns1"
                  :dataSource="dataSource1"
                  :pagination="false"
                >
                  <span slot="reportRate" slot-scope="text, record">
                    <a-progress :percent="text" size="small" status="active" strokeColor="#52C41A" />
                  </span>
                </a-table>
              </a-card>
            </div>
          </div>
        </div>
      </div>
      <!-- 地图 -->
      <div style="width: 100%; height: 400px" id="amapDiv">
        <baidu-map
          :center="center"
          :zoom="zoom"
          :style="{ height: '100%' }"
          :scroll-wheel-zoom="scrollZoom"
          NavigationControlType="BMAP_NAVIGATION_CONTROL_LARGE"
          @ready="mapReady"
        >
          <!-- 缩放控件 -->
          <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT" />
          <!-- 定位控件 -->
          <bm-geolocation
            anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
            :showAddressBar="true"
            :autoLocation="true"
          ></bm-geolocation>
          <!-- 比例尺控件 -->
          <bm-scale anchor="BMAP_ANCHOR_BOTTOM_RIGHT"></bm-scale>
          <!-- 信息窗体 -->
          <bm-info-window :position="position" :show="show" @close="infoWindowClose" @open="infoWindowOpen">
            <div style="width: 100%; display: flex; justify-content: space-between; font-weight: bold">
              <div style="flex: 1">
                <div>{{ $t('用户名称') }}：{{ mapInfo.userName }}</div>
                <div>{{ $t('表类型') }}：{{ mapInfo.mtName }}</div>
                <div>{{ $t('用户经度') }}：{{ mapInfo.user_meter_lng }}</div>
                <div>{{ $t('用户纬度') }}：{{ mapInfo.user_meter_lat }}</div>
              </div>
            </div>
          </bm-info-window>
        </baidu-map>
      </div>
    </a-col>
  </a-row>
</template>
      <script>
import { getAction, deleteAction, postAction,putAction } from '@/api/manage'
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { AreaChoosetMixin } from '@/mixins/AreaChooseMixin'
import TableDragResize from '@/mixins/TableDragResize'
import JInput from '@/components/jeecg/JInput'
import configService from '@/utils/service/config.service'
import { listSize } from '@/utils/util'
import Vue from 'vue'
import JDictSelectTag from '@/components/dict/JDictSelectTag.vue'
import { isUndefined, isUndefinedAndNull } from '@/utils/validate'
import { Mn100FkStatusObj } from '@/utils/constants/protocolConstant'
import * as echarts from 'echarts'
import i18n from '@/i18n'
const conditionData = [{ key: 0, title: i18n.t('未上报天数') }]
const cycleData = {
  0: ['>='],
  1: ['>='],
  2: ['<='],
}
const timecycleData = {
  0: ['天'],
  1: ['天'],
  2: ['元'],
}
export default {
  name: 'alarmIndex',
  mixins: [JeecgListMixin, mixinDevice, AreaChoosetMixin, TableDragResize],
  components: {
    JInput,
    JDictSelectTag,
  },
  data() {
    return {
      collapsed: false,
      //列设置
      settingColumns: [],
      data: [],
      visible: false,
      userPriceCode: [], // 价格编码
      description: 'meter_userinfo管理页面',
      url: {
        list: '/jeecg-charge/meter/meterUpData/meterNoUpRecordsByDate',
        exportXlsUrl: '/jeecg-charge/meter/meterUpData/exportXlsMeterNoUpRecordsByDate',
        getCountByCom: '/jeecg-charge/importantUser/getCountByCom',
        meterReportingRate: '/jeecg-charge/meter/waterAnalysis/meterReportingRate',
      },
      queryParam: {
        importantFlag: 1,
      },
      userCaliberList: [],
      cycleData,
      symbol: cycleData['0'],
      punctuation: cycleData['0'],
      units: timecycleData['0'],
      monad: timecycleData['0'],
      condition: 0,
      radioValue: '1',
      taskList: [
        {
          key: '1',
          label: '近三日上报率',
          num: '',
        },
        {
          key: '2',
          label: '开阀/关阀',
          num: '',
        },
        {
          key: '3',
          label: '未上报设备数',
          num: '',
        },
      ],
      cycleValue: '1',
      dataSource1: [],
      BMap: '',
      map: '',
      center: { lng: 118.904, lat: 31.915 }, //中心坐标
      centerPoint: { lng: 118.904, lat: 31.915 },
      zoom: 4, //初始缩放比
      scrollZoom: true, //允许鼠标滚轮缩放
      mapInfo: {},
      position: {},
      show: false,
      iconList: {
        0: require('@/assets/inspectionImage/circle_red.png'),
        1: require('@/assets/inspectionImage/circle_green.png'),
        2: require('@/assets/inspectionImage/circle_gray.png'),
      },
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${configService.apiUrl}/${this.url.importExcelUrl}`
    },
    // i18n：查询条件（未上报天数）选项使用 computed 以响应语言切换
    conditionData() {
      return conditionData.map(item => ({ ...item, title: this.$t(item.title) }))
    },
    // i18n：表头使用 computed 以响应语言切换
    columns() {
      return [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: (t, r, index) => {
            return parseInt(index) + 1
          },
        },
        {
          title: this.$t('表编号'),
          align: 'center',
          dataIndex: 'meterId',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('表类型'),
          align: 'center',
          dataIndex: 'mtName',
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t('用户编号'),
          align: 'center',
          dataIndex: 'userId',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('用户姓名'),
          align: 'center',
          dataIndex: 'userName',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('用户手机号'),
          align: 'center',
          dataIndex: 'phone',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('用户地址'),
          align: 'center',
          dataIndex: 'userAddr',
          width: 200,
          ellipsis: true,
          customRender: (t, r, index) => {
            if (r.userAreaName) {
              let i = r.userAreaName.indexOf('-')
              return r.userAreaName.slice(i + 1, r.userAreaName.length) + '-' + t
            } else {
              return t
            }
          },
        },
        {
          title: this.$t('表安装地址'),
          align: 'center',
          dataIndex: 'userMeterAddr',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('用户余额(元)'),
          align: 'center',
          dataIndex: 'userAccountNum',
          width: 150,
          ellipsis: true,
          customRender: (t, r, index) => {
            return t == null ? '--' : t
          },
        },
        {
          title: this.$t('最近上报时间'),
          align: 'center',
          dataIndex: 'meterSysTime',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('最近上报总用量(m³)'),
          align: 'center',
          dataIndex: 'meterTotalUse',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('最近上报阀门状态'),
          align: 'center',
          dataIndex: 'meterValveStatus',
          customRender: (t, r, index) => {
            const data = Mn100FkStatusObj
            if (isUndefined(data[t])) {
              return this.$t('其他')
            }
            return this.$t(data[t])
          },
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('电池状态'),
          align: 'center',
          dataIndex: 'meterBatteryStatus',
          customRender: (t, r, index) => {
            const data = { 0: '正常', 1: '欠压' }
            if (isUndefined(typeof data[t])) {
              return this.$t('其他')
            }
            return this.$t(data[t])
          },
          width: 100,
          ellipsis: true,
        },
      ]
    },
    columns1() {
      return [
        {
          title: this.$t('厂商名称'),
          dataIndex: 'mtComName',
          align: 'center',
        },
        {
          title: this.$t('设备总数'),
          dataIndex: 'deviceCount',
          align: 'center',
        },
        {
          title: this.$t('正常设备数'),
          dataIndex: 'reportCount',
          customRender: (t, r, index) => {
            return r.reportCount + '/' + r.deviceCount
          },
          align: 'center',
        },
        {
          title: this.$t('上报率'),
          dataIndex: 'reportRate',
          scopedSlots: { customRender: 'reportRate' },
          align: 'center',
          width: 120,
        },
      ]
    },
  },
  methods: {
    init(params) {
      this.radioValue = '1'
      this.searchReset()
      this.queryParam = Object.assign({},this.queryParam, params)
      this.loadData(1)
    },
    searchReset() {
      this.queryParam = {
        importantFlag: 1,
      }
      this.loadData(1)
    },
    handleperiodChange(value) {
      this.symbol = cycleData[value]
      this.punctuation = cycleData[value][0]
      this.units = timecycleData[value]
      this.monad = timecycleData[value][0]
      console.log(`selected ${value}`)
    },
    loadData(arg) {
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1
      }
      if (isUndefinedAndNull(this.queryParam.days) || this.queryParam.days === '') {
        this.queryParam.days = 3
      }
      var params = this.getQueryParams() //查询条件
      this.loading = true
      getAction(this.url.list, params).then(res => {
        if (res.success && res.result !== null) {
          this.dataSource = res.result.records
          this.ipagination.total = res.result.total
        }
        if (res.code === 510) {
          this.$message.warning(res.message)
        }
        this.loading = false
      })
    },
    changeRadio(e) {
      if (e == 1) {
      } else {
        this.$nextTick(() => {
          this.queryDeviceAnasis();
          this.getCountByCom()
        })
      }
    },
    queryDeviceAnasis() {
        putAction(this.url.meterReportingRate, {}).then((res) => {
            if(res.success){
                this.taskList[1].num = res.result.meterValveOpenCount+ '/' +res.result.meterValveCloseCount
                if(res.result.meterTotalCount>0) {
                    console.log(res.result.meterTotalCount)
                    this.taskList[0].num = Number(((res.result.lastThreeDayMeterReportCount/res.result.meterTotalCount)*100).toFixed(0))
                }
            }
        })
    },
    getCountByCom() {
      getAction(this.url.getCountByCom).then(res => {
        if (res.success) {
          this.dataSource1 = res.result
          this.taskList[2].num = res.result.length;
          this.setChart(res.result)
        }
      })
    },
    setChart(data) {
      let chart = echarts.init(document.getElementById('chart1'))
      let xData = data.map(item => item.mtComName)
      let yData1 = data.map(item => item.deviceCount) //设备数
      let yData2 = data.map(item => item.reportCount) //正常设备数
      let yData3 = data.map(item => item.reportRate) //上报率
      chart.setOption({
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: [this.$t('设备总数'), this.$t('正常设备数'), this.$t('上报率')],
        },
        color: ['#FFA500', '#00FF00', '#FF00FF'],
        xAxis: {
          data: xData,
        },
        yAxis: [
          {
            type: 'value',
            min: 0,
            name: this.$t('数量(只)'),
            nameTextStyle: {
              align: 'center',
            },
            // axisTick: {
            //   show: false,
            // },
            // axisLine: {
            //   show: false,
            // },
            axisLabel: {
              // color: '#D1F3FF',
              fontSize: 10,
            },
          },
          {
            type: 'value',
            min: 0,
            max: 100,
            interval: 20,
            name: this.$t('上报率(%)'),
            nameTextStyle: {
              align: 'center',
            },
            // splitLine: {
            //   show: false,
            //   lineStyle: {
            //     type: 'dotted',
            //     color: ['#074671'],
            //   },
            // },
            // axisTick: {
            //   show: false,
            // },
            // axisLine: {
            //   show: false,
            // },
            axisLabel: {
              formatter: '{value} %',
              // color: '#D1F3FF',
              fontSize: 10,
            },
          },
        ],
        series: [
          {
            data: yData1,
            type: 'bar',
            name: this.$t('设备总数'),
            barMaxWidth: 30,
          },
          {
            data: yData2,
            type: 'bar',
            name: this.$t('正常设备数'),
            barMaxWidth: 30,
          },
          {
            data: yData3,
            type: 'line',
            name: this.$t('上报率'),
          },
        ],
      })
      window.addEventListener('resize', function () {
        chart.resize()
      })
    },
    //地图默认方法
    mapReady({ BMap, map }) {
      let that = this
      this.BMap = BMap
      this.map = map
      map.enableDragging()
      map.enableScrollWheelZoom()
      map.enableDoubleClickZoom()
      map.enablePinchToZoom()
      map.enableKeyboard()
      map.clearOverlays()
      let params = this.getQueryParams()
      params.pageSize = 1000
      getAction(this.url.list, params).then(res => {
        if (res.success) {
          that.dataSource = res.result.records
          that.dataSource.forEach(item => {
            if (item.user_meter_lng && item.user_meter_lat) {
              var point = {
                lng: item.user_meter_lng,
                lat: item.user_meter_lat,
              }
              let myIcon = new BMap.Icon(
                //也可以设置不同坐标点上的icon，需要自己定义
                require('@/assets/inspectionImage/circle_gray.png'),
                new BMap.Size(40, 40), //图标可视区域大小
                { anchor: new BMap.Size(18, 18) } //图标定位点相对于图标左上角的偏移量
              )
              myIcon.setImageSize(new BMap.Size(30, 30)) // 设置icon大小
              var marker = new BMap.Marker(point, { icon: myIcon }) // 创建标注
              map.addOverlay(marker) // 将标注添加到地图中
              //icon标识内容位置
              let label = new BMap.Label(item.meterId, { offset: new BMap.Size(3, 0) })
              // 文本标识样式
              label.setStyle({
                // fontWeight: 600,
                fontSize: '14px',
                color: 'black',
                backgroundColor: '#fff',
                border: '1px solid #000',
                display: 'none',
              })
              marker.setLabel(label) // 为icon添加文本标识
            }
          })
        }
      })
      this.map.addEventListener('click', e => {
        that.mapInfo = that.dataSource.find(al => al.meterId == e.cb.Bc.textContent)
        that.position = {
          lng: that.mapInfo && that.mapInfo.user_meter_lng,
          lat: that.mapInfo && that.mapInfo.user_meter_lat,
        }
        that.show = true
      })
    },
    // 关闭窗体
    infoWindowClose() {
      this.show = false
    },
    // 打开窗体
    infoWindowOpen() {
      this.show = true
    },
  },
}
</script>
      <style scoped lang="less">
.drawer-bootom-button {
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: left;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
.top_list {
  display: flex;
  justify-content: space-between;
  height: 100px;
  .top_item {
    width: 32%;
    height: 100px;
    background: #e6f7ff;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .label {
      font-size: 14px;
      color: #999;
    }
    .num {
      font-size: 25px;
      font-weight: 600;
      color: #000;
    }
    .icon {
      width: 56px;
      height: 56px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;

      .anticon-check-circle {
        color: rgb(0, 162, 255);
        font-size: 30px;
      }
      .anticon-close-circle {
        color: #f5222d;
        font-size: 30px;
      }
    }
    .blue {
      background-color: rgba(0, 162, 255, 0.2);
    }
    .red {
      background-color: rgba(245, 34, 45, 0.2);
    }
    .progress {
      width: 56px;
      height: 56px;
      border-radius: 50%;
    }
  }
}
.chart-container {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  height: calc(100% - 110px);
  .item {
    border-radius: 10px;
    width: 49.5%;
    height: 100%;
    background: #eee;
  }
}
.ant-card-bordered {
  height: 100%;
  ::v-deep .ant-card-body {
    // height: calc(100% - 40px) !important;
    height: 349px;
  }
}
</style>
      <style scoped>
.my-area-select-tree /deep/ li .ant-tree-node-content-wrapper {
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  white-space: nowrap;
}
</style>
      <style scoped>
.table-fixed /deep/ .ant-table-bordered .ant-table-fixed-left table {
  border-right: 1px solid #e8e8e8;
}

.table-fixed /deep/ .resize-table-th {
  position: relative;
}
.table-fixed /deep/ .table-draggable-handle {
  border: 1px solid red;
  height: 100% !important;
  left: auto !important;
  right: -5px;
  cursor: col-resize;
  touch-action: none;
  border: none;
  position: absolute;
  transform: none !important;
  bottom: 0;
}
/* .new-table-card .ant-card-body .table-fixed {
  height: calc(100% - 120px);
} */
.radio_button_group {
  position: absolute;
  right: 14px;
  top: 70px;
}
</style>